var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceipt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F4F4FF;}\r\n\t.st1{fill:#5658D6;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.9,0H25.8C11.8,0,0.4,11.4,0.4,25.4v29c0,14,11.4,25.4,25.5,25.4h29.1c14,0,25.5-11.4,25.5-25.4v-29 C80.4,11.4,69,0,54.9,0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.7,26.3c-3.7,0-6.7,3-6.7,6.6s3,6.7,6.7,6.7c3.7,0,6.7-3,6.7-6.6l0,0C55.4,29.3,52.4,26.3,48.7,26.3z  M48.7,38c-2.7,0-5-2.2-5-5s2.2-5,5-5c2.7,0,5,2.2,5,5l0,0C53.7,35.7,51.4,38,48.7,38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.6,30.7l-2.7,2.7l-1.1-1.1l-1.2,1.2l1.7,1.7c0.2,0.2,0.4,0.2,0.6,0.2s0.4-0.1,0.6-0.2l3.3-3.3L50.6,30.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.4,
    y: 43.8,
    className: "st1",
    width: 11.6,
    height: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37,32.1h-9.1c-3.2,0-5.9,2.6-5.9,5.9h1.7c0-2.3,1.9-4.2,4.2-4.2H37c0.9-0.1,1.7,0.7,1.8,1.6s-0.7,1.7-1.6,1.8 c-0.1,0-0.1,0-0.2,0h-9.2v1.7H37c1.9,0.1,3.4-1.4,3.5-3.2c0.1-1.8-1.4-3.4-3.2-3.5C37.2,32.1,37.1,32.1,37,32.1L37,32.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.5,35.5c-0.5,0-0.8,0.4-0.8,0.8v0.8h4.2v-1.7H19.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57,46.3v11.7c0,1.4-1.1,2.5-2.5,2.5l0,0h-20c-1.4,0-2.5-1.1-2.5-2.5l0,0V38h-1.7v20c0,2.3,1.9,4.2,4.2,4.2 h19.9c2.3,0,4.2-1.9,4.2-4.2V46.3H57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54.5,22.2H37.9c-0.2,0-0.4,0.1-0.6,0.2L30.6,29l1.2,1.2l6.4-6.5h16.3c1.4,0,2.5,1.1,2.5,2.5l0,0v11.7h1.7 V26.3C58.6,24,56.8,22.2,54.5,22.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.5,22.4c-0.3-0.4-0.8-0.4-1.2,0l0,0L30.6,29c-0.2,0.2-0.2,0.4-0.2,0.6V33h1.7v-3l5-5v3 c0,0.5-0.4,0.8-0.8,0.8h-1.7v1.7h1.7c1.4,0,2.5-1.1,2.5-2.5l0,0v-5C38.7,22.8,38.6,22.6,38.5,22.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.7,44.6H22c0,3.2,2.6,5.9,5.9,5.9v-1.7C25.6,48.8,23.7,46.9,23.7,44.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.9,
    y: 48.8,
    className: "st1",
    width: 3.3,
    height: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.7,45.5v0.8c0,0.5,0.4,0.8,0.8,0.8h3.3v-1.7H18.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.9,40.4c-1-0.9-2.5-0.9-3.5,0L42.9,51.9c-0.4,0.3-0.4,0.8,0,1.2l0,0l2.3,2.3c0.2,0.2,0.4,0.2,0.6,0.2 c0.2,0,0.4-0.1,0.6-0.2l11.5-11.6l0,0C58.9,42.9,58.9,41.3,57.9,40.4z M56.7,42.6l-10.9,11l-1.1-1.1l11-10.9c0.3-0.3,0.8-0.3,1.1,0 l0,0C57.1,41.9,57.1,42.3,56.7,42.6L56.7,42.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.4,54.1l-2.4,1.2l1.2-2.4l-1.5-0.7l-2.3,4.6c-0.1,0.1-0.1,0.2-0.1,0.4c0,0.5,0.4,0.8,0.8,0.8 c0.1,0,0.2,0,0.4-0.1l4.6-2.3L45.4,54.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.5,
    y: 43.4,
    transform: "matrix(0.7069 -0.7073 0.7073 0.7069 -16.1946 50.9015)",
    className: "st1",
    width: 1.7,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.4,
    y: 56.3,
    className: "st1",
    width: 5.9,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.4,
    y: 52.1,
    className: "st1",
    width: 5,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.4,
    y: 48,
    className: "st1",
    width: 7.5,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.2,
    y: 56.3,
    className: "st1",
    width: 7.5,
    height: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.3,
    y: 52.1,
    className: "st1",
    width: 3.3,
    height: 1.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceipt);
export default __webpack_public_path__ + "static/media/receipt.5aa1d2376393eb8eacc9e0c00267610c.svg";
export { ForwardRef as ReactComponent };